import React, { PropsWithChildren, ReactNode } from 'react'
import { StyledTypography } from '@components/ui/Typography/StyledTypography'
import { Modal } from '@components/ui/Modal/Modal'
import { FooterAction } from '@components/ui/Modal/FooterAction'
import { usePageFlow } from '@hooks/usePageFlow'

interface ErrorModalProps extends PropsWithChildren {
  open: boolean
  onClose: () => void
  footer: ReactNode
  title: string
  message?: string
}

export const BasicErrorModal: React.FC<ErrorModalProps> = (props) => {
  const { open, onClose, footer, title, children, message } = props

  return (
    <Modal
      open={open}
      onClose={onClose}
      footer={footer}
      title={title}
    >
      {!children && message &&
        <StyledTypography dangerouslySetInnerHTML={{__html: message}}></StyledTypography>
      }
      {children && children}
    </Modal>
  )
}

interface MessageOptions {
  title: string
  message: string
  details?: string
  labels: {
    primary: string
    secondary?: string
  }
  dataAttributes?: {
    primary?: Record<string, string>
    secondary?: Record<string, string>
  }
}

interface DualActionErrorModalProps {
  open: boolean
  options: MessageOptions
  onPrimaryAction: () => void
  onSecondaryAction?: () => void
}

export const DualActionErrorModal: React.FC<DualActionErrorModalProps> = (props) => {
  const { open, options, onPrimaryAction, onSecondaryAction } = props
  const { modalOptions } = usePageFlow()

  return (
    <BasicErrorModal
      open={open}
      onClose={onPrimaryAction}
      footer={
        <>
          {
            onSecondaryAction && (
              <FooterAction
                onClick={onSecondaryAction}
                renderAs='link'
                label={options.labels.secondary}
                dataAttributes={options.dataAttributes?.secondary}
              />
            )
          }
          <FooterAction
            onClick={onPrimaryAction}
            renderAs='button'
            label={options.labels.primary}
            dataAttributes={options.dataAttributes?.primary}
          />
        </>
      }
      title={options.title}
    >
      <StyledTypography textAlign={modalOptions?.textAlign} dangerouslySetInnerHTML={{ __html: options.message }}></StyledTypography>
      {options.details && <StyledTypography textAlign={modalOptions?.textAlign}>{options.details}</StyledTypography>}
    </BasicErrorModal>
  )
}
